import React, { useLayoutEffect } from 'react';
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  breadcrumbsPropTypes,
  matchPropTypes,
} from '../../../common/resource/proptypes/CommonPropTypes';
import { EXCHANGE_RATE_PATH } from '../../../../config/paths';
import { clearExchangeRate, getExchangeRate } from '../../../../actions';
import Loader from '../../../common/Loader';
import Content from '../../../layout/Content';
import ExchangeRateToolbar from './ExchangeRateToolbar';
import NoDataResource from '../../../common/resource/NoDataResource';
import ExchangeRateBasicInformationResource from './resource/ExchangeRateBasicInformationResource';
import InternalResource from '../../../common/resource/InternalResource';

export const ExchangeRate = ({
  breadcrumbs,
  match: {
    params: { id: exchangeRateId },
  },
  exchangeRate,
  loading,
  dispatchGetExchangeRate,
  dispatchClearExchangeRate,
}) => {
  useLayoutEffect(() => {
    dispatchGetExchangeRate({ exchangeRateId });

    return () => dispatchClearExchangeRate();
  }, []);

  let content = null;
  let toolbar = null;
  if (loading) content = <Loader />;
  else if (exchangeRate.isEmpty()) {
    content = <NoDataResource returnPage={EXCHANGE_RATE_PATH} />;
  } else {
    const exchangeRateJSON = exchangeRate.toJS();
    content = (
            <>
              <h3>Información Básica</h3>
              <ExchangeRateBasicInformationResource {...exchangeRateJSON} />
              <InternalResource id={exchangeRateJSON.id}
                        createDate={exchangeRateJSON.createDate}
                        lastUpdate={exchangeRateJSON.lastUpdate}/>
            </>
      
  );
    toolbar = <ExchangeRateToolbar exchangeRateId={exchangeRateJSON.id} />;
  }

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Tasa de Cambio"
      toolbar={toolbar}
      content={content}
    />
  );
};

ExchangeRate.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  exchangeRate: PropTypes.instanceOf(Immutable.Map).isRequired,
  loading: PropTypes.bool,
  match: matchPropTypes.isRequired,
  dispatchGetExchangeRate: PropTypes.func.isRequired,
  dispatchClearExchangeRate: PropTypes.func.isRequired,
};

ExchangeRate.defaultProps = {
  loading: false,
};

const mapStateToProps = ({ AccountingUnit }) => ({
  breadcrumbs: [
    ...AccountingUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Tasas de Cambio',
      href: EXCHANGE_RATE_PATH,
    },
    {
      text: 'Ver',
      href: '',
    },
  ],
  exchangeRate: AccountingUnit.ExchangeRate.getIn(['current', 'content']),
  loading: !AccountingUnit.ExchangeRate.getIn(['current', 'activity']).isEmpty(),
});

const mapDispatchToProps = {
  dispatchGetExchangeRate: getExchangeRate,
  dispatchClearExchangeRate: clearExchangeRate,
};

export default connect(mapStateToProps, mapDispatchToProps)(ExchangeRate);
